export default __webpack_public_path__ + "static/media/delete.b3589991.svg";